// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"cc47db68","606":"b1037b52"}[chunkId] + ".chunk.js";
};